//#region Angular Imports

import { ITimeoutService } from 'angular'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import 'devextreme/ui/popup'
import 'devextreme/ui/scroll_view'
import 'devextreme/ui/toolbar'

//#endregion

import { FieldModel } from '../../api/api.models'
import { EventsNames } from '../../../helpers/events-names'
import { i18n } from '../../common/i18n/common.i18n'
import { $SCOPE_SERVICE_NAME } from '../../../services/system'

//#region Asset Imports

import './info-popup.scss'
import * as TEMPLATE from './info-popup.tpl.html'

//#endregion

interface InfoPopupScope extends ng.IScope {
    popupId: number
    popupOptions: DevExpress.ui.dxPopupOptions
    popupTitle: string
    popupVisible: boolean
    toolbarOptions: DevExpress.ui.dxToolbarOptions
    items: FieldModel[]
    source: InfoPopupSource
    treeListOptions: any
    maxWidth: number | string
    maxHeight: number | string
}

export interface InfoPopupSource {
    popupTitle: string
    infoText: string
}

export class InfoPopupDirective implements ng.IDirective {
    constructor() { }

    scope = {
        popupId: '=',
        source: '='
    }
    restrict = 'E'
    controller = [$SCOPE_SERVICE_NAME, ($scope: InfoPopupScope) => {

        $scope.popupVisible = false
        $scope.popupTitle = $scope.source.popupTitle
        $scope.maxWidth = 400
        $scope.maxHeight = 200

        $scope.popupOptions = {
            bindingOptions: {
                visible: 'popupVisible',
                title: 'popupTitle',
                maxWidth: 'maxWidth',
                maxHeight: 'maxHeight',
            },
            maxWidth: 400,
            maxHeight: 200,
            showTitle: true,
            closeOnOutsideClick: true,
            onHiding: () => { }
        }

        $scope.toolbarOptions = {
            items: [
                {
                    location: 'after',
                    widget: 'dxButton',
                    options: {
                        text: i18n('Common', 'Ok'),
                        onClick: () => {
                            $scope.popupVisible = false
                        }
                    }
                }
            ]
        }

        $scope.$on(EventsNames.OPEN_INFO_POPUP_POPUP + $scope.popupId, (event: ng.IAngularEvent, ...args: any[]) => {
            $scope.maxWidth = 400
            $scope.maxHeight = 200
            $scope.items = args[0]
            $scope.treeListOptions = args[1]
            if ($scope.treeListOptions) {
                $scope.maxWidth = 800
                $scope.maxHeight = 800
            }
            $scope.popupVisible = true
        })
    }]
    template = TEMPLATE
    transclude = true
}